import React from 'react';
import { Navigate, useParams, useNavigate } from 'react-router-dom';
import { Building2 } from 'lucide-react';
import AppHeader from '../components/layout/AppHeader';
import LoadingSpinner from '../components/shared/LoadingSpinner';
import LaunchDealDetailModal from '../components/launches/LaunchDealDetailModal';
import { useBusinessUnit } from '../hooks/useBusinessUnit';

export default function LaunchDealDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { availableUnits, isLoading } = useBusinessUnit();

  if (isLoading) {
    return (
      <>
        <AppHeader title="Deal — Empreendimentos" icon={Building2} />
        <div className="p-6"><LoadingSpinner /></div>
      </>
    );
  }

  if (!availableUnits || !availableUnits.includes('launches')) {
    return <Navigate to="/" replace />;
  }

  const handleClose = () => {
    if (window.history.length > 1) navigate(-1);
    else navigate('/launches/deals');
  };

  return (
    <>
      <AppHeader title="Deal — Empreendimentos" subtitle={`#${id}`} icon={Building2} />
      <LaunchDealDetailModal dealId={id} isOpen={true} onClose={handleClose} />
    </>
  );
}
